export const REVISION = 'a4c92b4';
